var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionItems({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4.125C3.75 3.91789 3.91789 3.75 4.125 3.75H7.875C8.08208 3.75 8.25 3.91789 8.25 4.125V7.875C8.25 8.08208 8.08208 8.25 7.875 8.25H4.125C3.91789 8.25 3.75 8.08208 3.75 7.875V4.125ZM4.5 4.5V7.5H7.5V4.5H4.5Z",
    fill: "white",
    strokeWidth: "2%"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 10.875C9.75 10.2537 10.2537 9.75 10.875 9.75H13.875C14.4963 9.75 15 10.2537 15 10.875V13.875C15 14.4963 14.4963 15 13.875 15H10.875C10.2537 15 9.75 14.4963 9.75 13.875V10.875ZM10.875 10.5C10.6679 10.5 10.5 10.6679 10.5 10.875V13.875C10.5 14.0821 10.6679 14.25 10.875 14.25H13.875C14.0821 14.25 14.25 14.0821 14.25 13.875V10.875C14.25 10.6679 14.0821 10.5 13.875 10.5H10.875Z",
    fill: "white",
    strokeWidth: "2%"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.125 1.5C1.125 1.29289 1.29289 1.125 1.5 1.125H16.5C16.7071 1.125 16.875 1.29289 16.875 1.5V16.5C16.875 16.7071 16.7071 16.875 16.5 16.875H1.5C1.29289 16.875 1.125 16.7071 1.125 16.5V1.5ZM1.875 1.875V16.125H16.125V1.875H1.875Z",
    fill: "white",
    strokeWidth: "2%"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 3.75C11.3395 3.75 10.5 4.58947 10.5 5.625C10.5 6.66053 11.3395 7.5 12.375 7.5C13.4105 7.5 14.25 6.66053 14.25 5.625C14.25 4.58947 13.4105 3.75 12.375 3.75ZM9.75 5.625C9.75 4.17525 10.9253 3 12.375 3C13.8247 3 15 4.17525 15 5.625C15 7.07475 13.8247 8.25 12.375 8.25C10.9253 8.25 9.75 7.07475 9.75 5.625Z",
    fill: "white",
    strokeWidth: "2%"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 9.75C5.76704 9.75 5.89689 9.83025 5.96041 9.9573L8.2104 14.4573C8.26852 14.5735 8.2623 14.7116 8.19397 14.8222C8.12565 14.9327 8.00497 15 7.875 15H3.375C3.24503 15 3.12433 14.9327 3.05601 14.8222C2.98768 14.7116 2.98147 14.5735 3.03959 14.4573L5.28959 9.9573C5.35311 9.83025 5.48296 9.75 5.625 9.75ZM5.625 10.9635L3.98176 14.25H7.26823L5.625 10.9635Z",
    fill: "white",
    strokeWidth: "2%"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionItems);
export default __webpack_public_path__ + "static/media/collection_items.cd69d04fa1eea9540d5dedf37f725421.svg";
export { ForwardRef as ReactComponent };